import { render, staticRenderFns } from "./ImageFullModal.vue?vue&type=template&id=4813c072&"
import script from "./ImageFullModal.vue?vue&type=script&lang=js&"
export * from "./ImageFullModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports